import React from 'react';
import styled from 'styled-components';

import { Card, Link } from 'components/core';
import { CategoryLink } from 'shop/hooks/categories/use-category-links';

// eslint-disable-next-line i18next/no-literal-string
const categoriesToOmit = new Set(['All', 'Apparel', 'N/A']);

type ShopCategoriesProps = {
  categories: CategoryLink[];
};

export function ShopCategories({ categories }: ShopCategoriesProps): JSX.Element {
  const filteredCategories = categories.filter(({ label }) => !categoriesToOmit.has(label));

  return (
    <Container>
      {filteredCategories.map(({ label, imgSrc, href }) => (
        <Link href={href} key={label}>
          <a href={href}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <Card height='150px' width='162px' justifyContent='space-between' pt='18px' pb='24px'>
              <img alt={label} src={imgSrc} height='75' width='108' object-fix='contain' />
              {label}
            </Card>
          </a>
        </Link>
      ))}
    </Container>
  );
}

const Container = styled.div`
  color: ${({ theme }) => theme.colors.grey[25]};
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  font-weight: bold;
`;
